/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumnreason3Inputs */

const en_sharereviewcolumnreason3 = /** @type {(inputs: Sharereviewcolumnreason3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const de_sharereviewcolumnreason3 = /** @type {(inputs: Sharereviewcolumnreason3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Sharereviewcolumnreason3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumnreason3 = /** @type {((inputs?: Sharereviewcolumnreason3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumnreason3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumnreason3(inputs)
	return de_sharereviewcolumnreason3(inputs)
});
export { sharereviewcolumnreason3 as "shareReviewColumnReason" }